<div class="sliderContenedor">
  <swiper *ngIf="banners.length > 0" [config]="swiperConfig" class="mySwiper">
    <ng-template swiperSlide *ngFor="let banner of banners">
      <div class="item">
        <a
          *ngIf="banner.urlRedireccion"
          [href]="banner.urlRedireccion"
          target="_blank"
          style="display: block; width: 100%; height: 100%"
        >
          <picture>
            <source
              loading="lazy"
              class="responImg lazyload"
              [srcset]="banner.imagenes.mobile || banner.imagenes.web"
              media="(max-width: 480px)"
              type="image/webp"
            />
            <source
              loading="lazy"
              class="responImg lazyload"
              [srcset]="banner.imagenes.tablet || banner.imagenes.web"
              media="(max-width: 640px)"
              type="image/webp"
            />
            <source
              loading="lazy"
              class="responImg lazyload"
              [srcset]="banner.imagenes.web"
              media="(max-width: 1200px)"
              type="image/webp"
            />
            <img
              loading="lazy"
              [src]="banner.imagenes.web"
              class="responImg lazyload"
              [alt]="banner.textoAlternativo || banner.titulo"
              width="100%"
              height="100%"
            />
          </picture>
        </a>
        <ng-container *ngIf="!banner.urlRedireccion">
          <picture>
            <source
              loading="lazy"
              class="responImg lazyload"
              [srcset]="banner.imagenes.mobile || banner.imagenes.web"
              media="(max-width: 480px)"
              type="image/webp"
            />
            <source
              loading="lazy"
              class="responImg lazyload"
              [srcset]="banner.imagenes.tablet || banner.imagenes.web"
              media="(max-width: 640px)"
              type="image/webp"
            />
            <source
              loading="lazy"
              class="responImg lazyload"
              [srcset]="banner.imagenes.web"
              media="(max-width: 1200px)"
              type="image/webp"
            />
            <img
              loading="lazy"
              [src]="banner.imagenes.web"
              class="responImg lazyload"
              [alt]="banner.textoAlternativo || banner.titulo"
              width="100%"
              height="100%"
            />
          </picture>
        </ng-container>
      </div>
    </ng-template>
  </swiper>
</div>
